import { render, staticRenderFns } from "./PerformanceImpact.vue?vue&type=template&id=702d8c46&scoped=true"
import script from "./PerformanceImpact.vue?vue&type=script&lang=js"
export * from "./PerformanceImpact.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702d8c46",
  null
  
)

export default component.exports